import {
    GET_ECI_LIST_PROGRESS, GET_ECI_LIST_SUCCESS, GET_ECI_LIST_FAILURE,
    ADD_ECI_PROGRESS, ADD_ECI_SUCCESS, ADD_ECI_FAILURE,
    EDIT_DELETE_ECI_PROGRESS, EDIT_DELETE_ECI_SUCCESS, EDIT_DELETE_ECI_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    eci: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const eci_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_ECI_LIST_SUCCESS:
            return { ...state, eci: action.eci, loading: false };
        case GET_ECI_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_ECI_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_ECI_PROGRESS:
            return { ...state, loading: true };
        case ADD_ECI_SUCCESS:
            return { ...state, eci: [...state.eci, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_ECI_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_ECI_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_ECI_SUCCESS:
            return {
                ...state,
                eci: state.eci.map((eci) =>
                    eci.id === action.payload.id ? action.payload : eci
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_ECI_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default eci_reducer;